import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { createPath } from "@odata/BindingContext";
import {
    IPrCSSZSubmissionCaregivingEntity,
    PrCareReceiverEntity,
    PrCSSZSubmissionCaregivingDetailEntity,
    PrCSSZSubmissionCaregivingEntity
} from "@odata/GeneratedEntityTypes";
import { PrSubmissionSubtypeCode, PrSubmissionTypeCode } from "@odata/GeneratedEnums";
import {
    handleIdentificationTypeBeforeSave,
    initIdentificationTypeLocalPath
} from "@pages/payroll/employee/Employee.utils";
import {
    addNewCaregivingIntervalLineItem,
    cleanUpCaregivingIntervalsBeforeSave,
    clearCaregivingReturnToWorkBeforeSave,
    clearEntityAccordingToActionType,
    handleCaregivingActionsChange,
    handleIsCaringPersonallyChange,
    handleWorkedInDaysChange,
    initWorkedInDays,
    PrCSSZSubmissionEntity
} from "@pages/payroll/submission/submissionTypes/PrCSSZSubmission.utils";
import PrCSSZSubmissionNEMPRIFormView from "@pages/payroll/submission/submissionTypes/PrCSSZSubmissionNEMPRIFormView";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";

class PrCSSZSubmissionCaregivingFormView extends PrCSSZSubmissionNEMPRIFormView<IPrCSSZSubmissionCaregivingEntity> {
    typeCode = PrSubmissionTypeCode.EmployersNotificationOfAnEmployeesBenefitApplication;
    subTypeCode = PrSubmissionSubtypeCode.NempriCaregiving;

    typeSpecificOnAfterLoad(isNew: boolean): Promise<void> {
        const { storage } = this.props;

        // init local contexts from data, todo: only when isStartType?
        initIdentificationTypeLocalPath(storage,
            storage.data.bindingContext
                .navigate(PrCSSZSubmissionCaregivingEntity.Detail)
                .navigate(PrCSSZSubmissionCaregivingDetailEntity.CareReceiver),
            PrCareReceiverEntity.IdentificationNumber
        );

        initWorkedInDays(storage);
        if (!storage.data.entity.Detail?.CaregivingIntervals?.length) {
            addNewCaregivingIntervalLineItem(storage, storage.data.bindingContext.navigate(createPath(PrCSSZSubmissionEntity.Detail, PrCSSZSubmissionCaregivingDetailEntity.CaregivingIntervals)));
        }

        return super.typeSpecificOnAfterLoad(isNew);
    }

    handleChange(e: ISmartFieldChange): void {
        const { storage } = this.props;
        handleCaregivingActionsChange(e, storage);
        handleIsCaringPersonallyChange(e, storage);
        handleWorkedInDaysChange(e, storage);

        super.handleChange(e);
        // keep after storage -> handleChange to have updated data
    }

    onBeforeSave(data?: IPrCSSZSubmissionCaregivingEntity): IPrCSSZSubmissionCaregivingEntity {
        data = super.onBeforeSave(data);
        const { storage } = this.props;

        const careReceiverBc = storage.data.bindingContext
            .navigate(PrCSSZSubmissionCaregivingEntity.Detail)
            .navigate(PrCSSZSubmissionCaregivingDetailEntity.CareReceiver);
        handleIdentificationTypeBeforeSave(data, storage.data.bindingContext, careReceiverBc, {
            identificationPropName: PrCareReceiverEntity.IdentificationNumber
        });

        data = cleanUpCaregivingIntervalsBeforeSave(data, storage);
        data = clearEntityAccordingToActionType(data, storage);
        data = clearCaregivingReturnToWorkBeforeSave(data, storage);

        return data;
    }
}

export default withPermissionContext(PrCSSZSubmissionCaregivingFormView);